import { render, staticRenderFns } from "./project-teams.vue?vue&type=template&id=3f15ef6b&scoped=true"
import script from "./project-teams.vue?vue&type=script&lang=js"
export * from "./project-teams.vue?vue&type=script&lang=js"
import style0 from "./project-teams.vue?vue&type=style&index=0&id=3f15ef6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f15ef6b",
  null
  
)

export default component.exports